const CACHE_KEY_PREFIX = 'policy_pilot_';

const createStorageActions = (storage: Storage) => ({
  store: (key: string, data: any) => {
    storage.setItem(CACHE_KEY_PREFIX + key, JSON.stringify(data));
  },
  get: (key: string) => {
    const data = storage.getItem(CACHE_KEY_PREFIX + key);
    if (!data) return null;
    return JSON.parse(data);
  },
  remove: (key: string) => {
    storage.removeItem(CACHE_KEY_PREFIX + key);
  },
  removeByKey: (key: string) => {
    storage.removeItem(key);
  },
});

const local = createStorageActions(localStorage);
const session = createStorageActions(sessionStorage);

const actions = {
  store: local.store,
  get: local.get,
  remove: local.remove,
  removeByKey: local.removeByKey,
  local,
  session,
};

export default actions;
